// extracted by extract-css-chunks-webpack-plugin
module.exports = {"emptyCartWrapper":"UxsVO"};